'use strict'

/**
 * MODULE API GOOGLE
 * Recherche une adresse
 */

import mustache from 'mustache'

let inputRecherche
let formGroupRecherche
let formGroupAutocomplete

function gererPays(codpaystri) {
    // gestion indicatif téléphone
    $('.j_select_indicatifTel').val(
        $('.j_select_indicatifTel')
            .find('[data-trigramme="' + codpaystri + '"]')
            .val()
    )

    // on cherche le codepays
    let codpays = ''
    const itemPays = $('.j_select_autresPays').find(
        '[data-trigramme="' + codpaystri + '"]'
    )
    if (itemPays != undefined) {
        codpays = itemPays.data('value')
    }
    // DOM-TOM
    if (
        codpays == '' ||
        codpays == 'GP' ||
        codpays == 'GF' ||
        codpays == 'RE' ||
        codpays == 'MQ' ||
        codpays == 'YT' ||
        codpays == 'NC' ||
        codpays == 'PF' ||
        codpays == 'WF' ||
        codpays == 'PM'
    ) {
        codpays = 'FR'
    }

    $("[name='codePays']").val(codpays)
}

function hideGoogleShowAdress() {
    if (formGroupRecherche.length > 0) {
        formGroupAutocomplete.hide()
        formGroupRecherche.show()

        afficherSaisieManuelAdresse()
    } else {
        formGroupAutocomplete.show()
    }
}

function afficherSaisieManuelAdresse() {
    $('.j-adress_manuel').unbind('click')
    $('.j-adress_manuel').click(function () {
        formGroupAutocomplete.show()
        formGroupRecherche.hide()
        const adresse = $("[name='adresse']").val()
        const adresseAutoComplete = $("[name='adresseG']").val()

        if (adresseAutoComplete != '' && adresse == '') {
            $("[name='adresse']").val(adresseAutoComplete)
            $("[name='adresseG']").val('')
        }

        $("[name='adresse']").focus()
    })
}

// Liste des pays=developers.arcgis.com/rest/geocode/api-reference/geocode-coverage.htm
function ListeAdresseAjax(recherche) {
    const parametres = {
        text: recherche,
        maxSuggestions: 5,
        countryCode: $('#template').data('countryCodes'),
        f: 'json'
    }

    $.ajax({
        type: 'GET',
        url: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest',
        data: parametres,
        success: function (reponse) {
            const template = $('#template').html()

            if (
                reponse.suggestions !== undefined &&
                reponse.suggestions !== null
            ) {
                const rendered = mustache.render(template, reponse)
                $('.autocomplete-adress').html(rendered)

                afficherSaisieManuelAdresse()

                $('.adress-item').click(function () {
                    const magickey = $(this).data('key')
                    if (magickey !== undefined) {
                        infoAdresseAjax(magickey)
                    }
                })
            }
        },
        failure: function (response) {}
    })
}

function infoAdresseAjax(key) {
    $('.autocomplete-adress').hide()

    const parametres = {
        outFields: '*',
        magicKey: key,
        f: 'json'
    }

    $.ajax({
        type: 'GET',
        url: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates',
        data: parametres,
        success: function (reponse) {
            if (
                reponse.candidates !== undefined &&
                reponse.candidates[0] !== undefined
            ) {
                const data = reponse.candidates[0].attributes
                const codepostal = data.Postal
                const adresse = data.StAddr
                const ville = data.City
                const pays = data.Country

                $("[name='adresseG']").val(reponse.candidates[0].address)
                $("[name='cp']").val(codepostal)
                $("[name='ville']").val(ville)
                $("[name='adresse']").val(adresse)

                gererPays(pays)

                if (pays == 'FRA') {
                    verifierCodepostalVille(codepostal, ville)
                }

                $('.j-adress_manuel').click()
            }
        },
        failure: function (response) {}
    })
}

function Process($formGroupRecherche, $inputRecherche, $formGroupAutocomplete) {
    formGroupRecherche = $formGroupRecherche
    inputRecherche = $inputRecherche
    formGroupAutocomplete = $formGroupAutocomplete

    $(document).ready(function () {
        hideGoogleShowAdress()

        inputRecherche.keydown(function () {
            if (inputRecherche.val().length < 3) {
                $('.autocomplete-adress').hide()
                return
            }

            $('.autocomplete-adress').show()

            ListeAdresseAjax(inputRecherche.val())
        })

        inputRecherche.blur(function () {
            setTimeout(function () {
                $('.autocomplete-adress').hide()
            }, 500)
        })
    })
}

function verifierCodepostalVille(codepostal, ville) {
    const data = {
        cp: codepostal
    }

    $.ajax({
        type: 'POST',
        url: '/Inscription/GetListOfVilleByCodePostal',
        data: data,
        success: function (data) {
            if (
                data === null ||
                data.ListVilles === null ||
                data.ListVilles === undefined ||
                data.ListVilles.length === 0
            ) {
                $('.j-adress_manuel').click()
                $("[name='ville']").val('')
                $("[name='cp']").change()
            } else {
                const villetrouve = data.ListVilles.find(function (element) {
                    return (
                        element.NomVille.toUpperCase() === ville.toUpperCase()
                    )
                })

                if (villetrouve == undefined || villetrouve == null) {
                    $('.j-adress_manuel').click()
                    $("[name='ville']").val('')
                    $("[name='cp']").change()
                }
            }
        },
        failure: function (response) {
            $('.j-adress_manuel').click()
            $("[name='ville']").val('')
            $("[name='cp']").change()
            $("[name='ville']").focus()
        }
    })
}

export default {
    Process: Process
}
